import WidgetOptions from './WidgetOptions';

export default WidgetOptions;
